export const WHATSAPP_NUMBER = '905300887386';

export const buildWhatsAppMessage = (categoryName: string, city?: string): string => {
  const cityLine = city ? `📍 Şehir: ${city}\n` : '';
  return `Merhaba 👋\n\nKampanya Kupon sistemi üzerinden\n👉 ${categoryName}\n${cityLine}\nile ilgili kampanyalar hakkında bilgilendirme almak istiyorum.\n\nBu doğrultuda tarafıma WhatsApp üzerinden bildirim gönderilmesini onaylıyorum.`;
};

export const openWhatsApp = (categoryName: string, city?: string): void => {
  const message = buildWhatsAppMessage(categoryName, city);
  const encoded = encodeURIComponent(message);
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
